export default function fetchCupom({cupom}) {
    return fetch(process.env.VUE_APP_API_ORIGIN + '/api/cupom', {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({cupom}),
    });
}